export const tooltipContent = (slottedElement: HTMLElement | null): string => {
  if (!slottedElement) return "";

  /*                                                            */
  const textWrapper = slottedElement.querySelector(".tab-item-text");
  const content = textWrapper ? textWrapper.textContent : slottedElement.textContent;

  return `<div aria-hidden="true">${content}</div>`;
};
